module.exports = __webpack_public_path__ + "static/media/profile1.6b8e8c7b.webp";